import UIDropdown from 'components/ui/dropdown/Dropdown';
import useActiveVolumes from 'stores/activeVolumes';
import React from 'react';
import { formattedImageData, VolumeIds } from 'types';
import { loadNewVolume } from 'utils/cornerstone/setup';
import { applyDefaultColorMap, getDefaultLesion } from 'utils/heatmaps/heatmaps';
import { getViewport } from 'utils/utilities';

export const handleDropdownItemClick = async (
  activeVolumeIds: VolumeIds,
  setActiveLesion: React.Dispatch<React.SetStateAction<string>>,
  isVesselReconstructionActive?: boolean,
  toggleVesselReconstruction?: () => void,
  setActiveVolumeData?: React.Dispatch<React.SetStateAction<any>>,
) => {
  // If vessel reconstruction is active, deactivate it first
  if (isVesselReconstructionActive && toggleVesselReconstruction) {
    await toggleVesselReconstruction();
  }

  setActiveVolumeData(activeVolumeIds);
  await loadNewVolume(activeVolumeIds);

  const defaultLesion = getDefaultLesion();
  setActiveLesion(defaultLesion);
  if (defaultLesion) {
    applyDefaultColorMap();
  }
  const viewport = getViewport();
  if (viewport) {
    viewport.render();
  }
};

type ImageDropdownProps = {
  formattedImages: formattedImageData[];
};
const ImageDropdown = ({ formattedImages }: ImageDropdownProps) => {
  const { activeVolumesData, setActiveVolumeData } = useActiveVolumes();

  // Calculate initial index without side effects
  const getActiveIndex = () => {
    if (activeVolumesData) {
      return formattedImages.findIndex((img) => img.image === activeVolumesData.image);
    }
    return formattedImages.findIndex((img) => img.selectedImage);
  };

  const [selectedImageIndex, setSelectedImageIndex] = React.useState(getActiveIndex());

  // Handle context update in useEffect
  React.useEffect(() => {
    const initialIndex = formattedImages.findIndex((img) => img.selectedImage);
    const formattedVolumeData = {
      image: formattedImages[initialIndex].image,
      vessel: formattedImages[initialIndex]?.vessel,
      lesions: formattedImages[initialIndex]?.lesions,
    };
    setActiveVolumeData(formattedVolumeData);
  }, []);

  return (
    <UIDropdown
      items={formattedImages}
      activeIndex={selectedImageIndex}
      setActiveIndex={setSelectedImageIndex}
    />
  );
};

export default ImageDropdown;
